import { Box, Button, Checkbox, Dialog, DialogContent, DialogTitle, Grid, Typography } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import { buttonBoxStyle, buttonStyle, containerStyle, errorTypographyStyle, gridBoxStyle, gridCommonStyle, gridStyle, searchBarBoxStyle, selectedGridStyle, titleStyle, typographyStyle } from './TransferLeads_CSS'
import CustomTextField from '../CustomTextField'
import _ from "lodash";
import { assignLeadToWORKer, fetchDistrictsWithLeads, fetchLeadsUnderDistrict, fetchStatesWithLeads, fetchStatesWithLeadsDash, getAllLeadTemplates, getDistrictsList, getMemberStateHeadDetails, getMembersDistrictHeadDetails, getStatesList, getStatesWithLeads, getWORKersByNameAndContact, getWORKersForHead, transferLeads } from '../../backend/backendApis';
import HttpService from '../../backend/requestApis';
import { useNavigate } from 'react-router-dom';
import { lightGrey, maroon, mediumGrey, red } from '../../assets/colors';
import Loader from '../Loader';
import CustomDropDown from '../CustomDropDown';
import { genderList } from '../../utils/constants';
import { Https } from '@mui/icons-material';
import { useSelector } from 'react-redux';

const TransferLead = (props) => {
    const navigate = useNavigate()

    const [designation, setDesignation] = useState(null)
    const [searchText, setSearchText] = useState('')
    const [searchResult, setSearchResult] = useState(null)
    const [selectedRow, setSelectedRow] = useState(null)
    const [isHover, setIsHover] = useState(null)
    const [WORKerContact, setWORKerContact] = useState(null)
    const [isLoader, setIsLoader] = useState(false)
    const [error, setError] = useState(null)
    const [statesList, setStatesList] = useState([])
    const [districtsList, setDistrictsList] = useState([])
    const [selectedGender, setSelectedGender] = useState('Gender')
    const [selectedState, setSelectedState] = useState('State')
    const [selectedDistrict, setSelectedDistrict] = useState('District')
    const [selectedLeads, setSelectedLeads] = useState([])
    const [templateList, setTemplateList] = useState([])
    const [selectedTemplate, setSelectedTemplate] = useState('Select Lead Template')
    const [selectedTemplateId, setSelectedTemplateId] = useState(null)

    // const stateList = useSelector(state => state.selectedState.selectedState)
    const districtList = useSelector(state => state?.selectedDistrict?.selectedDistrict)

    React.useEffect(() => {
        setSelectedGender('Gender')
        setSelectedState('State')
        setSelectedDistrict('District')
        setStatesList([])
        setDistrictsList([])
        setSelectedLeads([])
        setSearchText(null)
        setSearchResult(null)
        setSelectedRow(null)
        setWORKerContact(null)
        setIsLoader(false)
        setError(false)
        if( props.dialogStatus){
            setIsLoader(true)
            if(localStorage.getItem('designation') === 'admin'){
                setDesignation('admin')
            } else if( localStorage.getItem('isStateHead') === 'true'){
                setDesignation('stateHead')
            } else if(localStorage.getItem('isDistrictHead') === 'true'){
                setDesignation('districtHead')
            }
            
            let options = {
                url: getAllLeadTemplates,
                method: 'GET',
                headers: {
                    Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
                }
            }
            HttpService(options).then((resp) => {
                let templates = resp?.data?.data

                templates = templates.map((temp) => (
                    {name: temp['title'], id: temp['_id']}
                ))

                setTemplateList(() => templates)
                setIsLoader(() => false)
            }).catch(err => {
                if(err.status === 403){
                    setIsLoader(false)
                    navigate('/login')
                } else {
                    console.log("Error in fetching the templates: ", err)
                    setError('Error in fetching the Lead Templates. Please Contact Support.')
                    setIsLoader(false)
                }
            })
        }
    }, [props.dialogStatus])

    useEffect(() => {
        if(props.dialogStatus && props.isAdvanced)
        {
            setIsLoader(() => true)
            let options = {
                url: fetchStatesWithLeadsDash,
                method: 'GET',
                params:{
                    contactNumber: localStorage.getItem('contact')
                },
                headers: {
                    Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
                }
            }
            if( designation === 'admin'){
                options['params']['gender'] = selectedGender
            }
            HttpService(options).then((result) => {
                let reqArray = []
                result?.data?.data?.map((ele) => {
                    reqArray.push({'name': ele})
                })
                setStatesList(() => reqArray)
                setSelectedState(() => reqArray[0]['name'])
                setIsLoader(() => false)
            }).catch(err => {
                if(err.status === 403){
                    setIsLoader(false)
                    navigate('/login')
                } else {
                    console.log("Error in fetching the states: ", err)
                    setError('Error in fetching the States. Please Contact Support.')
                    setIsLoader(false)
                }
            })
        }
    }, [selectedGender, props.dialogStatus])

    useEffect(() => {
        if(props?.dialogStatus){
            setIsLoader(() => true)
            let options = {
                url: fetchDistrictsWithLeads,
                method: 'GET',
                params: {
                    contactNumber: localStorage.getItem('contact'),
                    state: selectedState
                },
                headers: {
                    Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
                }
            }
            if( designation === 'admin'){
                options['params']['gender'] = selectedGender
            }
            HttpService(options).then((result) => {
                let reqArray = []
                    result?.data?.data?.map((ele) => {
                        reqArray.push({'name': ele})
                })
                setDistrictsList(() => reqArray)
                setIsLoader(() => false)
            }).catch(err => {
                if(err.status === 403){
                    setIsLoader(false)
                    navigate('/login')
                } else {
                    console.log("Error in fetching the districts: ", err)
                    setError('Error in fetching the Districts. Please Contact Support.')
                    setIsLoader(false)
                }
            })
        }
    }, [selectedState])

    useEffect(() => {
        if( selectedDistrict != 'District'){
            setIsLoader(() => true)
            let options = {
                url: fetchLeadsUnderDistrict,
                method: 'GET',
                params: {
                    state: selectedState,
                    district: selectedDistrict
                },
                headers: {
                    Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
                }
            }
            if( designation === 'admin'){
                options['params']['gender'] = selectedGender
            }
            HttpService(options).then((result) => {
                const leads = result?.data?.data || []
                setSelectedLeads(Array.isArray(leads) ? leads : [])
                setIsLoader(() => false)
            }).catch(err => {
                if(err.status === 403){
                    setIsLoader(false)
                    navigate('/login')
                } else {
                    console.log("Error in fetching the Leads under Districts: ", err)
                    setError('Error in fetching the Leads under Districts. Please Contact Support.')
                    setIsLoader(false)
                }
            })
        }

    }, [selectedDistrict])

    const updateGender = (value) => {
        setSelectedGender(value)
        setSelectedLeads([])
        setSelectedState('State')
        setSelectedDistrict('District')
        setStatesList([])
        setDistrictsList([])
    }

    const updateSelectedTemplate = (template) => {
        setSelectedTemplate(template.name)
        setSelectedTemplateId(template.id)

    }

    const updateSelectedState = (state) => {
        setSelectedLeads([])
        setSelectedDistrict('District')
        setDistrictsList([])
        setSelectedState(state)
    }

    React.useEffect(() => {
        try{
            setIsLoader(true)
            if( props.headDashboard && localStorage.getItem('isStateHead') === 'true') {
                setIsLoader(false)
                return
            }
            if( !(selectedState === 'State')){
                let options = {
                    url: fetchDistrictsWithLeads,
                    method: 'GET',
                    params: {
                        'gender': selectedGender,
                        'state': selectedState
                    },
                    headers: {
                        Authorization: localStorage.getItem("token")
                            ? `Bearer ${localStorage.getItem("token")}`
                            : null,
                    },
                }
                HttpService(options).then((result) => {
                    const districts = result?.data?.data || []
                    setDistrictsList(Array.isArray(districts) ? districts : [])
                    setIsLoader(false)
                }).catch(err => {
                    setIsLoader(false)
                    if (err?.status === 403) {
                        localStorage.clear();
                        navigate("/login");
                    } else {
                        setError(`Error in Fetching Districts. Please Contact Support.`)
                    }
                })
            } else {
                setIsLoader(false)
            }
        } catch(err){
            setIsLoader(false)
        }
    }, [selectedState, selectedGender])

    const getSearchResult = (searchText) => {
        try{
            setIsLoader(true)
            let options = {
                url: getWORKersForHead,
                method: 'GET',
                params: {
                    searchText: searchText
                },
                headers: {
					Authorization: localStorage.getItem("token")
						? `Bearer ${localStorage.getItem("token")}`
						: null,
				},
            }
            HttpService(options).then((result) => {
                setSearchResult(result?.data?.data)
                setIsLoader(false)
            }).catch(err => {
                console.log(`Error in getting WORKers: ${err}`) 
                setIsLoader(false)
                if (err?.status === 403) {
                    localStorage.clear();
                    // setIsLoading(false);
                    navigate("/login");
                } else {
                    setError(`Error in Fetching WORKers. Please Contact Support.`)
                }
            })
        } catch(err){
            console.log(`Error in getting WORKers: ${err}`)
            setError(`Error in Fetching WORKers. Please Contact Support.`)
            setIsLoader(false)
        }
    }

    const handleTransfer = () => {
        try{
            setIsLoader(true)
            let options = {
                url: props.headDashboard ? assignLeadToWORKer : transferLeads,
                method: 'POST',
                payload: {
                    "WORKerContactNumber": WORKerContact,
                    "leadContactArray": props.isAdvanced ? selectedLeads : props.transferLeadData,
                    "templateId": selectedTemplateId
                },
                headers: {headers: {
                    Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
                }}
            }
            HttpService(options).then(resp => {
                setIsLoader(false)
                props.dialogstatusFunc(true)

            }).catch(err => {
                setIsLoader(false)
                console.log(`Error in transferring lead: ${err}`)    
                if (err?.status === 403) {
                    localStorage.clear();
                    // setIsLoading(false);
                    navigate("/login");
                } else {
                    setError(`Error in Transferring. Please Contact Support.`)
                }
            })

        } catch(err){
            console.log(`Error in transferring lead: ${err}`)
            setError(`Error in Transferring. Please Contact Support.`)
            setIsLoader(false)
        }
    }

    const updateSearch = (searchValue) => {
        setSearchText(searchValue)
        debouncedApiCall(searchValue)
    }

    const debouncedApiCall = useCallback(
        _.debounce((searchValue) => {
        setSelectedRow(null)
        getSearchResult(searchValue)
        }, 500), []
    )
  return (
    <>
        <Dialog maxWidth='sm' fullWidth open={props.dialogStatus} onClose={() => props.dialogstatusFunc()}>
            <DialogTitle sx={{height: "1.8rem", padding: "0.4rem 0rem 0.4rem 1rem"  }} style={titleStyle}>
                Transfer Lead
            </DialogTitle>
            <DialogContent style={containerStyle}>
                <>
                {props.isAdvanced === true && 
                    <>
                        <Box style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
                            padding: '0.5rem'
                        }}>
                            <Grid container spacing= {1}>
                                {props.headDashboard ? (
                                    <>
                                        {designation === 'admin' && 
                                            <>
                                                <Grid item xs={6} sm={6}>
                                                    <CustomDropDown list={genderList} placeHolder='Gender' value={selectedGender} setFunc={updateGender}>
                                                    </CustomDropDown>
                                                </Grid>
                                            </>
                                        }

                                        <Grid item xs={6} sm={6}>
                                            <CustomDropDown 
                                                list={statesList} 
                                                placeHolder='State' 
                                                value={selectedState} 
                                                setFunc={updateSelectedState}>
                                            </CustomDropDown>
                                        </Grid>

                                        <Grid item xs={6} sm={6}>
                                            <CustomDropDown 
                                                list={districtsList} 
                                                placeHolder='District' 
                                                value={selectedDistrict} 
                                                setFunc={(value) => setSelectedDistrict(value)}></CustomDropDown>
                                        </Grid>
                                    </>
                                ) : (
                                    <>
                                        {localStorage.getItem('designation') === 'admin' &&
                                        <>
                                            <Grid item xs={6} sm={6}>
                                                <CustomDropDown list={genderList} placeHolder='Gender' value={selectedGender} setFunc={(value) => {setSelectedGender(value)
                                                        setSelectedLeads([])
                                                        setSelectedState('State')
                                                        setSelectedDistrict('District')
                                                        setStatesList([])
                                                        setDistrictsList([])
                                                    }
                                                }></CustomDropDown>
                                            </Grid>
                                            <Grid item xs={6} sm={6}>
                                            </Grid>
                                        </>
                                        }
                                        <Grid item xs={6} sm={6}>
                                            <CustomDropDown list={statesList} placeHolder='State' value={selectedState} setFunc={updateSelectedState}></CustomDropDown>
                                        </Grid>
                                        <Grid item xs={6} sm={6}>
                                            <CustomDropDown list={districtsList} placeHolder='District' value={selectedDistrict} setFunc={(value) => setSelectedDistrict(value)}></CustomDropDown>
                                        </Grid>
                                    </>
                                )}
                            </Grid>

                            {selectedLeads?.length > 0 && <Box>
                                <Typography style = {{color: maroon, padding: '1rem'}}>Total Leads: {selectedLeads?.length}</Typography>
                            </Box>}
                        </Box>
                    </>
                }
                    <Box style={{display: 'flex', justifyContent: 'center', padding: '0.5rem 0.2rem 0.5rem 0.2rem'}}>
                        <CustomDropDown regular={true} width='13rem' list={templateList}
                            value={selectedTemplate}
                            placeHolder='Select Lead Template'
                            setFunc={updateSelectedTemplate}
                            isValueRequired={true}
                        ></CustomDropDown>
                    </Box>
                    
                    <Box style={searchBarBoxStyle}>
                        
                        <CustomTextField 
                            placeHolder='Enter Text to Search'
                            value={searchText}
                            setFunc={updateSearch}
                        ></CustomTextField>

                    </Box>
                    {isLoader && <Loader></Loader>}
                    {searchResult?.length > 0 ?
                    <Box style={gridBoxStyle} sx={{maxHeight: '30vh'}}>
                            {
                                searchResult.map((WORKer, index) => {
                                    return(
                                        <>
                                            <Grid container spacing={1} style={selectedRow === index || isHover === index ? selectedGridStyle : gridStyle } 
                                                onMouseEnter={() => {setIsHover(index)}}
                                                onMouseLeave={() => {setIsHover(null)}}
                                                onClick={() => {setSelectedRow(index)
                                                    setWORKerContact(WORKer.contactNumber)
                                                }
                                                
                                                }>
                                                <Grid item xs={3} sm={3} style={{...gridCommonStyle, borderLeft: `1px solid`}}>
                                                    {WORKer.name}
                                                </Grid>
                                                <Grid item xs={3} sm={3} style={{...gridCommonStyle}}>
                                                    {WORKer.contactNumber}
                                                </Grid>
                                                <Grid item xs={3} sm={3} style={{...gridCommonStyle}}>
                                                    {WORKer.district}
                                                </Grid>
                                                <Grid item xs={3} sm={3}style={{...gridCommonStyle, borderRight: '0px solid'}}>
                                                    {WORKer.chapter}
                                                </Grid>
                                            </Grid>
                                        </>
                                    )       
                                })
                            }
                    </Box> : <>
                    {searchResult?.length === 0 ?
                    <Typography style={typographyStyle}>
                        No Result Found
                    </Typography> : <></>}
                    </>}
                    <Box style={buttonBoxStyle}>
                        <Button style={{...buttonStyle, backgroundColor: red}}
                            onClick={() => {
                                setSelectedRow(null)
                                setSearchText(null)
                                setSearchResult([])
                                props.dialogstatusFunc()
                            }}
                        >Close</Button>
                        <Button style={{...buttonStyle, 
                        opacity: (() => {
                            if (!props.isAdvanced) return selectedRow === null ? '0.5' : '1'
                            
                            if (props.headDashboard) {
                                const isAdmin = localStorage.getItem('designation') === 'admin'
                                const isStateHead = localStorage.getItem('isStateHead') === 'true'
                                const isDistrictHead = localStorage.getItem('isDistrictHead') === 'true'
                                
                                if (isAdmin) {
                                    return (selectedRow === null || selectedGender === 'Gender' || selectedState === 'State' || selectedDistrict === 'District') ? '0.5' : '1'
                                } else if (isStateHead) {
                                    return (selectedRow === null || selectedDistrict === 'District') ? '0.5' : '1'
                                } else if (isDistrictHead) {
                                    return selectedRow === null ? '0.5' : '1'
                                }
                            }
                            
                            return (selectedRow === null || selectedGender === 'Gender' || selectedState === 'State' || selectedDistrict === 'District') ? '0.5' : '1'
                        })()}}
                            disabled={(() => {
                                if (!props.isAdvanced) return selectedRow === null
                                
                                if (props.headDashboard) {
                                    const isAdmin = localStorage.getItem('designation') === 'admin'
                                    const isStateHead = localStorage.getItem('isStateHead') === 'true'
                                    const isDistrictHead = localStorage.getItem('isDistrictHead') === 'true'
                                    
                                    if (isAdmin) {
                                        return selectedRow === null || selectedGender === 'Gender' || selectedState === 'State' || selectedDistrict === 'District'
                                    } else if (isStateHead) {
                                        return selectedRow === null || selectedDistrict === 'District'
                                    } else if (isDistrictHead) {
                                        return selectedRow === null
                                    }
                                }
                                
                                return selectedRow === null || selectedGender === 'Gender' || selectedState === 'State' || selectedDistrict === 'District'
                            })()}
                            onClick={() => {
                                handleTransfer()
                            }}
                        >Transfer</Button>
                    </Box>
                    {error && 
                        <Typography style={errorTypographyStyle}>
                            {error}
                        </Typography>
                    }
                </>

            </DialogContent>

        </Dialog>
    </>
  )
}

export default TransferLead
